import SidebarTabSwitcher from "../../borrowerDetails/shared/SidebarTabSwitcher";

/**
 * Sub-tab bar for a sidebar tab's inner sections (the borrower Information tab's
 * All / Details / Loan Role… row, the property Information tab's equivalent).
 *
 * Wraps the same `SidebarTabSwitcher` copy the sidebars use for their primary
 * tabs (`borrowerDetails/shared` — there's a second, unused copy under
 * `sidebar/components`), so the two rows read as one navigation system.
 * Previously this was a pill `FilterTabSwitcher`, which looked like a filter
 * chip group sitting under a tab bar.
 *
 * Spans the full drawer width; the surrounding surface and the sticky
 * behaviour belong to the toolbar that hosts it.
 */
const SubTabSwitcher = ({ tabs, value, onChange, sx }) => (
  <SidebarTabSwitcher
    hideDivider
    tabs={tabs}
    value={value}
    onChange={onChange}
    sx={{
      minHeight: "unset",
      px: 1,
      borderBottom: "1px solid #eef1f4",
      // Overrides SidebarTabSwitcher's 11px — these labels are card titles now,
      // so there are more of them and they're longer.
      "& .MuiTab-root": { fontSize: "10px" },
      // Two classes, so it outweighs the base component's `.MuiButtonBase-root
      // { fontWeight: 400 }`. Keyed off `.MuiTab-root.Mui-selected` rather than
      // `.Mui-selected` on purpose: the latter would replace the wrap styles'
      // `.Mui-selected` block wholesale and take the active underline and tint
      // with it.
      "& .MuiTab-root.Mui-selected": { fontWeight: 700 },
      ...sx,
    }}
    buttonSx={{ minWidth: "40px", px: 1.5, py: 1.25 }}
  />
);

export default SubTabSwitcher;
